import React from 'react'
import {logger} from 'yougile-util'
import {popupHost} from '@components/common/base/popup/popup-host'
import {Padding} from '../design-system/types'
import {Popup} from './popup'

export type OpenPopupProps = {
  content: React.ReactNode
  zIndex: number
  onCloseRequest?: () => boolean
  title?: React.ReactNode
  width: number
  autoHeight?: boolean
  footer?: React.ReactNode
  noScroll?: boolean
  type?: 'popup' | 'dialog'
  rounded?: '8' | '16'
  overlay?: {
    opacity: number
  }

  subTitle?: string
  paddings?: Padding
  headerPaddings?: Padding
  contentPaddings?: Padding
  footerPaddings?: Padding
  noCross?: boolean
}

export type PropsGetter = (props: {close: () => void}) => OpenPopupProps

export type OpenPopupReturnType = {
  close: () => void
  update: (nextProps: OpenPopupProps) => void
}

export function openPopup(getProps: PropsGetter) {
  let releasePopup: (() => void) | undefined
  let stateSetter: React.Dispatch<React.SetStateAction<OpenPopupProps>>

  const close = () => {
    releasePopup?.()
    releasePopup = undefined
  }

  const update = (nextProps: OpenPopupProps) => {
    if (releasePopup === undefined) {
      logger.error(
        'You cannot update popup props, because popup is already closed'
      )
      return
    }
    if (typeof stateSetter === 'function') {
      stateSetter(prevState => ({...prevState, ...nextProps}))
    } else {
      /* React component is not mounted yet */
      config = {...config, ...nextProps}
    }
  }

  if (typeof getProps !== 'function') {
    logger.error('openPopup: getProps should be a function')
    return {
      close,
      update
    }
  }

  let config = getProps({
    close
  })

  releasePopup = popupHost.addPopup(() => {
    const [state, setState] = React.useState(config)
    stateSetter = setState

    const {
      title,
      subTitle,
      zIndex,
      width,
      paddings,
      headerPaddings,
      contentPaddings,
      footerPaddings,
      autoHeight = true,
      footer,
      noScroll = true,
      type = 'dialog',
      rounded = '16',
      content,
      noCross = true,
      onCloseRequest,
      overlay
    } = state
    return (
      <Popup
        minHeightAuto
        inlineDisplay={false}
        close={() => {
          if (onCloseRequest ? onCloseRequest() : true) {
            releasePopup?.()
          }
        }}
        title={title}
        subTitle={subTitle}
        width={width}
        paddings={paddings}
        headerPaddings={headerPaddings}
        contentPaddings={contentPaddings}
        footerPaddings={footerPaddings}
        autoHeight={autoHeight}
        footer={footer}
        noScroll={noScroll}
        type={type}
        rounded={rounded}
        popupInWnd={true}
        overlay={overlay}
        zIndex={zIndex}
        noCross={noCross}
      >
        {content}
      </Popup>
    )
  })

  return {
    close,
    update
  }
}
